<template>
  <section class="resonance-section">
    <div class="resonance-container">
      <div class="resonance-header">
        <h2 class="resonance-title">{{ translations[locale].title }}</h2>
        <p class="resonance-subtitle">{{ translations[locale].subtitle }}</p>
      </div>
      <div class="timeline">
        <div class="timeline-line"></div>
        <div class="timeline-items">
          <div class="timeline-item">
            <div class="timeline-content left">
              <h3 class="timeline-date">2022 Q4</h3>
              <ul class="timeline-list">
                <li>{{ translations[locale].q4.item1 }}</li>
                <li>{{ translations[locale].q4.item2 }}</li>
                <li>{{ translations[locale].q4.item3 }}</li>
              </ul>
            </div>
            <div class="timeline-dot"></div>
          </div>
          <!-- <div class="timeline-item">
            <div class="timeline-content right">
              <h3 class="timeline-date">2023 Q1</h3>
              <ul class="timeline-list">
                <li>{{ translations[locale].q1.item1 }}</li>
                <li>{{ translations[locale].q1.item2 }}</li>
                <li>{{ translations[locale].q1.item3 }}</li>
              </ul>
            </div>
            <div class="timeline-dot"></div>
          </div> -->
          <div class="timeline-item">
            <div class="timeline-content right">
              <h3 class="timeline-date">2023 Q2</h3>
              <ul class="timeline-list">
                <li>{{ translations[locale].q2.item1 }}</li>
                <li>{{ translations[locale].q2.item2 }}</li>
                <li>{{ translations[locale].q2.item3 }}</li>
              </ul>
            </div>
            <div class="timeline-dot"></div>
          </div>
          <!-- <div class="timeline-item">
            <div class="timeline-content right">
              <h3 class="timeline-date">2024 Q3-Q4</h3>
              <ul class="timeline-list">
                <li>{{ translations[locale].q3q4.item1 }}</li>
                <li>{{ translations[locale].q3q4.item2 }}</li>
                <li>{{ translations[locale].q3q4.item3 }}</li>
              </ul>
            </div>
            <div class="timeline-dot"></div>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/stores/language'

const store = useStore()
const locale = computed(() => store.locale)

const translations = {
  zh: {
    title: '發展路線圖',
    subtitle: 'KOMA的發展計畫和重要里程碑',
    q4: {
      item1: '完成技術開發及測試',
      item2: '發佈測試網絡',
      item3: '完成安全稽核'
    },
    q1: {
      item1: '主網上線',
      item2: '代幣發行',
      item3: 'DeFi生態建設'
    },
    q2: {
      item1: '主網正式上線運行，並引入SDR',
      item2: 'GameFi平臺上線',
      item3: '跨鏈橋部署'
    },
    q3q4: {
      item1: 'Layer2擴展方案',
      item2: 'DAO治理系統升級',
      item3: '全球生態擴張'
    }
  },
  en: {
    title: 'Development Roadmap',
    subtitle: 'KOMA\'s development plan and key milestones',
    q4: {
      item1: 'Complete technical development and testing',
      item2: 'Launch test network',
      item3: 'Complete security audit'
    },
    q1: {
      item1: 'Mainnet launch',
      item2: 'Token issuance',
      item3: 'DeFi ecosystem construction'
    },
    q2: {
      item1: 'The main network is officially launched and running, and SDR is introduced',
      item2: 'GameFi platform launch',
      item3: 'Cross-chain bridge deployment'
    },
    q3q4: {
      item1: 'Layer2 scaling solution',
      item2: 'DAO governance system upgrade',
      item3: 'Global ecosystem expansion'
    }
  }
}
</script>

<style lang="scss" scoped>
.resonance-section {
  padding: 96px 0;
  position: relative;
}

.resonance-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 32px;
}

.resonance-header {
  text-align: center;
  margin-bottom: 48px;
}

.resonance-title {
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  font-weight: 700;
  line-height: 1.2;
  color: #F8FAFC;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #60A5FA 0%, #A78BFA 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  letter-spacing: 0.05em;
}

.resonance-subtitle {
  font-size: clamp(0.875rem, 1.5vw, 1rem);
  color: #4B5563;
  line-height: 1.5;
  max-width: 672px;
  margin: 0 auto;
}

.timeline {
  position: relative;
  padding: 48px 0;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #E5E7EB;
  transform: translateX(-50%);
}

.timeline-items {
  position: relative;
}

.timeline-item {
  position: relative;
  margin-bottom: 64px;

  &:last-child {
    margin-bottom: 0;
  }
}

.timeline-dot {
  position: absolute;
  left: 50%;
  top: 0;
  width: 16px;
  height: 16px;
  background: #6366F1;
  border-radius: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.timeline-content {
  width: 45%;
  padding: 24px;
  background: rgba(99, 102, 241, 0.05);
  border-radius: 8px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  &.left {
    margin-right: auto;
  }

  &.right {
    margin-left: auto;
  }
}

.timeline-date {
  font-size: 1.25rem;
  font-weight: 600;
  color: #F8FAFC;
  margin-bottom: 1rem;
}

.timeline-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.timeline-list li {
  color: #4B5563;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
}

// 响应式设计
@media screen and (max-width: 1200px) {
  .timeline-content {
    width: 39%;
  }
}

@media screen and (max-width: 768px) {
  .resonance-section {
    padding: 60px 0;
  }

  .resonance-container {
    padding: 0 24px;
  }

  .timeline-line {
    left: 24px;
  }

  .timeline-dot {
    left: 24px;
  }

  .timeline-content {
    width: calc(100% - 90px);
    margin-left: 48px !important;
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 480px) {
  .resonance-section {
    padding: 40px 0;
  }

  .resonance-container {
    padding: 0 16px;
  }

  .timeline-content {
    padding: 16px;
  }
}

// 深色模式支持
@media (prefers-color-scheme: dark) {
  .resonance-subtitle {
    color: #9CA3AF;
  }

  .timeline-line {
    background: #374151;
  }

  .timeline-content {
    background: rgba(99, 102, 241, 0.1);
  }

  .timeline-list li {
    color: #9CA3AF;
  }
}
</style>